import classNames from 'classnames';
import React, { useCallback } from 'react';
import { unsplashClient } from '@trello/unsplash';

interface PhotoAttributionProps {
  size?: string | null;
  user: { name: string; links: { html: string } };
}

export const PhotoAttribution: React.FC<PhotoAttributionProps> = (props) => {
  const { size, user } = props;
  const handleClick = useCallback(
    (e: React.MouseEvent) => e.stopPropagation(),
    [],
  );

  return (
    <div className={classNames('photo-attribution-component', size)}>
      <a
        className="photo-attribution-component-attribution-link"
        href={unsplashClient.appendAttribution(user.links.html)}
        onClick={handleClick}
        target="_blank"
        title={user.name}
      >
        {user.name}
      </a>
    </div>
  );
};
